<template>
	<el-form ref="enterpriserVo" :model="enterpriserVo" :inline="true" label-width="100px" size="mini" @submit.prevent="onSubmit" style="margin:15px;width:80%;min-width:800px;">
            <el-form-item label="企业名称">
             <el-col>
			<el-input  style="width:510px" v-model="enterpriserVo.name" @blur="getEnterpriseByCenterData()"></el-input>
             </el-col>
		</el-form-item>	
        <el-form-item label="法人">
             <el-col>
			<el-input v-model="enterpriserVo.legalPerson" ></el-input>
             </el-col>
		</el-form-item>
         <el-form-item label="营业范围">
			<el-col>
			<el-input  v-model="enterpriserVo.businessScope" ></el-input>
             </el-col>
		</el-form-item>
         <el-form-item label="注册地址">
             <el-col>
			<el-input style="width:510px" v-model="enterpriserVo.regAddr" ></el-input>
             </el-col>
		</el-form-item>
         <el-form-item label="纳税人性质">
             <el-col>
			<el-input  v-model="enterpriserVo.taxpayerType" ></el-input>
             </el-col>
		</el-form-item>
         <el-form-item label="纳税人识别号">
             <el-col>
			<el-input  v-model="enterpriserVo.taxpayerNum" ></el-input>
             </el-col>
		</el-form-item>
         <el-form-item label="开户银行">
             <el-col>
			<el-input  v-model="enterpriserVo.openingBank" ></el-input>
             </el-col>
		</el-form-item>
         <el-form-item label="银行账户">
             <el-col>
			<el-input  v-model="enterpriserVo.bankAccount" ></el-input>
             </el-col>
		</el-form-item>
         <el-form-item label="联系人">
             <el-col>
			<el-input  v-model="enterpriserVo.linkMan" ></el-input>
             </el-col>
		</el-form-item>
         <el-form-item label="联系电话">
             <el-col>
			<el-input  v-model="enterpriserVo.linkPhone" ></el-input>
             </el-col>
		</el-form-item>
        	
        <el-col :span="24" style="text-align:center">
        <el-form-item>
         <el-button type="primary" @click="onSubmit">保存</el-button>
        </el-form-item>
         </el-col>
	</el-form>
</template>

<script>
import { RequestPost } from '../../api/api'
import { PageSize } from '../../api/api';
import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
	export default {
		data() {
			return {
				page:{                   //地址信息列表
					pageSize:PageSize,   //一页显示的条数
					criteria:'',
					customerId: sessionStorage.getItem("userId"),//客户ID
				},	
				enterpriserVo:{
					name:'',
					legalPerson:'',
					businessScope:'',
					regAddr:'',
					taxpayerType:'',
					taxpayerNum:'',

				},
                options: regionData,
                 selectedOptions: []
			}
		},
		methods: {

			//保存绑定所属公司
			onSubmit() {
				this.enterpriserVo.userId = sessionStorage.getItem("userId");//客户ID
				RequestPost("/enterpriser/saveEnterpriseAndSaveToCustomer",this.enterpriserVo).then(response=>{
					if(response.code=="0000"){
						this.$message({
								message: response.message,
								type: 'success'
							}); 
						this.loadData();
					}else{
						this.$message({
								message: response.message,
								type: 'error'
							});
					}
				});
			}, 
			
			//通过企业名称获取企业信息
			getEnterpriseByCenterData(){
				RequestPost("/enterpriser/getEnterpriseByCenterData",this.enterpriserVo).then(response => {
                    if(response.code == '0000'){
							this.enterpriserVo = response.data;
							if(response.code=="0000"){
								vm.$Modal.success({
								title: "提示",
								content: response.message+"无需修改，请直接保存！"
								});
							}else{
								vm.$Modal.success({
								title: "提示",
								content: response.message+"查询成功，请直接保存！"
								});
							}
					}
					
				}).catch(error => {
					
								// this.$router.push({ path: '/login' });				
				})  
			},

			//加载数据
			loadData(){
				this.enterpriserVo.userId = sessionStorage.getItem("userId");//客户ID
				RequestPost("/enterpriser/getEnterpriseByCustomerEnterpriseID",this.enterpriserVo).then(response=>{
					this.enterpriserVo = response.data;
				});
			},

            handleChange (value) {
                console.log(value)
      		},
		},

		//初始化数据
		created:function(){
			this.loadData();
		},
	}

</script>


// WEBPACK FOOTER //
// affiliate_company.vue?1d40eba4